import { last } from 'lodash'
import Config from 'react-native-config'
import { Device } from '@src/config'
import {
  Tutorial,
  TutorialSensorKind,
  TutorialStepActionLink,
  TutorialStepActionTypes,
  TutorialStepActionVideo,
  TutorialStepPlatformLink,
} from '../models/tutorials.types'

export const isTutorialVideo = (
  action: TutorialStepActionVideo | TutorialStepActionLink | TutorialStepPlatformLink,
): action is TutorialStepActionVideo =>
  action.__typename === TutorialStepActionTypes.TutorialStepActionVideo
export const isTutorialLink = (
  action: TutorialStepActionVideo | TutorialStepActionLink | TutorialStepPlatformLink,
): action is TutorialStepActionLink =>
  action.__typename === TutorialStepActionTypes.TutorialStepActionLink

export const isPlatformLink = (
  action: TutorialStepActionVideo | TutorialStepActionLink | TutorialStepPlatformLink,
): action is TutorialStepPlatformLink =>
  action.__typename === TutorialStepActionTypes.TutorialStepPlatformLink

export const platformLinkUrl = (link: TutorialStepPlatformLink) => {
  const url = Device.ios ? link.ios.url : link.android.url
  const urlWithoutScheme = last(url.split('://'))
  return `${Config.APP_SCHEME}://${urlWithoutScheme}`
}

export const shouldNavigateToNextTutorial = (link: TutorialStepPlatformLink | undefined) => {
  if (!link) {
    return false
  }
  return platformLinkUrl(link).includes('app/tutorials')
}

// integration through Apple Health, Health Connect, or Terra
export const isThirdPartyIntegrationTutorial = (tutorial: Tutorial) => {
  return [
    TutorialSensorKind.DexcomG6,
    TutorialSensorKind.DexcomG7,
    TutorialSensorKind.DexcomStelo,
    TutorialSensorKind.LingoThirdParty,
    TutorialSensorKind.Libre123IndirectSyncing,
  ].includes(tutorial.sensorKind)
}

export const isSteloRealtimeTutorial = (tutorial: Tutorial) => {
  return tutorial.sensorKind === TutorialSensorKind.DexcomSteloRealtime
}

export const isDexcomG6G7RealtimeTutorial = (tutorial: Tutorial) => {
  return (
    tutorial.sensorKind === TutorialSensorKind.DexcomG6Realtime ||
    tutorial.sensorKind === TutorialSensorKind.DexcomG7Realtime
  )
}
